import { Box, Grid, Typography } from '@mui/material';
import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  isLoadingSelector,
  successSelector
} from 'src/store/selectors/statusSelector';
import {
  CLEAR_CLIENT_IDENTITY_VALIDATION,
  LOAD_CLIENT_IDENTITY_VALIDATION,
  loadClientIdentityValidation
} from 'src/store/actions/clientActions';
import { selectIdentityValidation } from 'src/store/selectors/clientSelectors';
import { useParams } from 'react-router-dom';
import Preloader from 'src/components/Preloader';
import ValidationDetail from './ValidationDetail';
import useStyles from '../styles';

const NuffiView = () => {
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const { id } = useParams();
  const clientValidation = useSelector(selectIdentityValidation);
  const loading = useSelector(
    isLoadingSelector([LOAD_CLIENT_IDENTITY_VALIDATION.action])
  );
  const success = useSelector(
    successSelector([LOAD_CLIENT_IDENTITY_VALIDATION.action])
  );
  const { classes } = useStyles();

  useEffect(() => {
    dispatch(loadClientIdentityValidation(id));
    return () => {
      dispatch({ type: CLEAR_CLIENT_IDENTITY_VALIDATION });
    };
  }, [id]);

  return (
    <Box mt={3}>
      <Grid container>
        <Grid item xs={12}>
          <Box className={classes.titleContainer}>
            <Typography
              style={{ fontWeight: '400', textTransform: 'capitalize' }}
              color="primary"
              variant="h1"
            >
              {t('CLIENTS_VIEW.CLIENT_DETAIL.IDENTITY')}
            </Typography>
          </Box>
        </Grid>
        {loading && !success ? (
          <Grid
            item
            xs={12}
            sx={{
              display: 'flex',
              justifyContent: 'center',
              alignItems: 'center',
              maxHeight: '70vh'
            }}
          >
            <Preloader style={{ height: '68vh' }} />
          </Grid>
        ) : (
          <>
            <Grid item sx={12} lg={12}>
              <ValidationDetail validation={clientValidation} />
            </Grid>
          </>
        )}
      </Grid>
    </Box>
  );
};

export default NuffiView;
